import React, { useState, useEffect } from "react"
import types from "prop-types"
import queryParameter, { QP_CACHE_KEY } from "utils/queryParameter"
import removeQueryStringFromLocation from "utils/removeQueryStringFromLocation"
import * as API from "services/api"
import { errorToast } from "shared/toast"
import CachedQueryParamsContext from "../CachedQueryParamsContext"

const CachedQueryParamsContextProvider = ({ children }) => {
  const [cachedParams, setCachedParams] = useState(null)

  useEffect(() => {
    const qpCacheKey = queryParameter(QP_CACHE_KEY)

    if (!qpCacheKey) {
      setCachedParams({})
      return
    }

    const fetchCachedParams = async () => {
      const response = await API.cachedQueryParams(qpCacheKey)

      if (response.ok) {
        removeQueryStringFromLocation()
        setCachedParams(response.data)
      } else {
        errorToast("Something went wrong. Unable to load pre-filled form data.")
        setCachedParams({})
      }
    }

    fetchCachedParams()
  }, [])

  if (cachedParams === null) return null

  const contextConsumerValue = {
    cachedParams,
  }

  return (
    <CachedQueryParamsContext.Provider value={contextConsumerValue}>
      {children}
    </CachedQueryParamsContext.Provider>
  )
}

CachedQueryParamsContextProvider.propTypes = {
  children: types.node.isRequired,
}

export default CachedQueryParamsContextProvider
